/**
 * Created by Greg on 4/4/2016.
 */

let initialUIState = { // We need to keep track of lots of dialogs here
    showComputeServeModal: false,
    showNetLoadModal: false,
    showNodeAddModal: false,
    showNodeEditModal: false,
    showLinkAddModal: false,
    showLinkEditModal: false,
    showNetExportModal: false,
    showIPAddressModal: false,
    showPortNumberModal: false,
    showDistanceWeightsModal: false,
    showRandomCapsModal: false,
    showShortPathModal: false,
    showWidePathModal: false,
    showMinTreeModal: false,
    showNetInfo: false,
    showPathInfo: false,
    showHelp: true,
    showPathLoadModal: false,
    showDemandLoadModal: false,
    showKShortPathsModal: false,
};

export default function uiState(state = initialUIState, action) {
    switch (action.type) {
        case 'CLOSE_RAND_CAP_DIALOG':
            return Object.assign({}, state, {showRandomCapsModal: false});
        case 'SHOW_RAND_CAP_DIALOG':
            return Object.assign({}, state, {showRandomCapsModal: true});
        case 'CLOSE_DIST_WEIGHT_DIALOG':
            return Object.assign({}, state, {showDistanceWeightsModal: false});
        case 'SHOW_DIST_WEIGHT_DIALOG':
            return Object.assign({}, state, {showDistanceWeightsModal: true});
        case 'CLOSE_PORT_NUMBER_DIALOG':
            return Object.assign({}, state, {showPortNumberModal: false});
        case 'SHOW_PORT_NUMBER_DIALOG':
            return Object.assign({}, state, {showPortNumberModal: true});
        case 'CLOSE_IP_ADDRESS_DIALOG':
            return Object.assign({}, state, {showIPAddressModal: false});
        case 'SHOW_IP_ADDRESS_DIALOG':
            return Object.assign({}, state, {showIPAddressModal: true});
        case 'SHOW_COMPUTE_SERVE_DIALOG':
            return Object.assign({}, state, {showComputeServeModal: true});
        case 'CLOSE_COMPUTE_SERVE_DIALOG':
            return Object.assign({}, state, {showComputeServeModal: false});
        case 'SHOW_NET_LOAD_DIALOG':
            return Object.assign({}, state, {showNetLoadModal: true});
        case 'SHOW_NET_EXPORT_DIALOG':
            return Object.assign({}, state, {showNetExportModal: true});
        case 'CLOSE_NET_EXPORT_DIALOG':
            return Object.assign({}, state, {showNetExportModal: false});
        case 'PRE_NET_NODE_ADD':
            return Object.assign({}, state, {showNodeAddModal: true});
        case 'NET_NODE_ADD':
        case 'CLOSE_NODE_ADD_DIALOG':
            return Object.assign({}, state, {showNodeAddModal: false});
        case 'CLOSE_NET_LOAD_DIALOG':
        case 'GOOD_NET_LOAD_CLOSE':
            return Object.assign({}, state, {showNetLoadModal: false});
        case 'PRE_NET_LINK_ADD':
            return Object.assign({}, state, {showLinkAddModal: true});
        case 'CLOSE_LINK_ADD_DIALOG':
        case 'NET_LINK_ADD':
            return Object.assign({}, state, {showLinkAddModal: false});
        case 'NET_NODE_EDIT':
        case 'CLOSE_NODE_EDIT_DIALOG':
            return Object.assign({}, state, {showNodeEditModal: false});
        case 'PRE_NODE_EDIT':
            return Object.assign({}, state, {showNodeEditModal: true});
        case 'NET_LINK_EDIT':
        case 'CLOSE_LINK_EDIT_DIALOG':
            return Object.assign({}, state, {showLinkEditModal: false});
        case 'PRE_LINK_EDIT':
            return Object.assign({}, state, {showLinkEditModal: true});
        case 'SHOW_HELP':
            return Object.assign({}, state, {showHelp: action.flag});
        case 'SHOW_NET_INFO':
            return Object.assign({}, state, {showNetInfo: action.flag});
        case 'SHOW_PATH_INFO':
            return Object.assign({}, state, {showPathInfo: action.flag});
        case 'CLOSE_MIN_TREE_DIALOG':
            return Object.assign({}, state, {showMinTreeModal: false});
        case 'SHOW_MIN_TREE_DIALOG':
            return Object.assign({}, state, {showMinTreeModal: true});
        case 'CLOSE_SHORT_PATH_DIALOG':
            return Object.assign({}, state, {showShortPathModal: false});
        case 'SHOW_SHORT_PATH_DIALOG':
            return Object.assign({}, state, {showShortPathModal: true});
        case 'CLOSE_WIDE_PATH_DIALOG':
            return Object.assign({}, state, {showWidePathModal: false});
        case 'SHOW_WIDE_PATH_DIALOG':
            return Object.assign({}, state, {showWidePathModal: true});
        case 'CLOSE_PATH_LOAD_DIALOG':
            return Object.assign({}, state, {showPathLoadModal: false});
        case 'SHOW_PATH_LOAD_DIALOG':
            return Object.assign({}, state, {showPathLoadModal: true});
        case 'CLOSE_DEMAND_LOAD_DIALOG':
            return Object.assign({}, state, {showDemandLoadModal: false});
        case 'SHOW_DEMAND_LOAD_DIALOG':
            return Object.assign({}, state, {showDemandLoadModal: true});
        case 'CLOSE_KSHORT_PATHS_DIALOG':
            return Object.assign({}, state, {showKShortPathsModal: false});
        case 'SHOW_KSHORT_PATHS_DIALOG':
            return Object.assign({}, state, {showKShortPathsModal: true});
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/uiStateReducer.js